module.exports = __webpack_public_path__ + "static/media/TW.b6654bb8.png";